// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"je_a bhe_a bhe_j bhe_q bhe_st bhe_su bhe_w"};